export const headCells = [
  { field: 'supplierId', headerName: 'Id' },
  {
    field: 'businessName',
    headerName: ' Supplier Name',
    minWidth: 350,
  },
  { field: 'status', headerName: 'Status' },
];
